import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import ActivityItemTypeService from "../../../../Domain/ActivityItemType/ActivityItemType.service";
import NoteSearchFilters from "../../../Presentational/ItemSearchPiece/NoteSearchFilters";
import ActivityFeed from "../../../Presentational/ActivityItem/ActivityFeed";
import ActivityService from "../../../../Services/Activity.service";
const AdvisorStudentsStaffNotesTab = (props) => {
    const [noteSearch, setNoteSearch] = React.useState(null);
    const itemSearch = React.useMemo(() => {
        var _a, _b;
        if (noteSearch) {
            return {
                global: {
                    activityItemTypeIds: [ActivityItemTypeService.NoteId],
                    createdByPeoplePersonIds: (_a = noteSearch.creators) === null || _a === void 0 ? void 0 : _a.map((creator) => creator.personId),
                    createdDateFrom: noteSearch.createdDateFrom,
                    createdDateTo: noteSearch.createdDateTo,
                    contextPeoplePersonIds: [props.student.personId],
                },
                latestValue: [
                    {
                        types: (_b = noteSearch.noteTypes) === null || _b === void 0 ? void 0 : _b.map((noteType) => noteType.id),
                        updatedDateFrom: noteSearch.updatedDateFrom,
                        updatedDateTo: noteSearch.updatedDateTo,
                    },
                ],
            };
        }
        return {
            global: {
                contextPeoplePersonIds: [props.student.personId],
                activityItemTypeIds: [ActivityItemTypeService.NoteId],
            },
            latestValue: [],
        };
    }, [noteSearch, props.student.personId]);
    const poll = React.useCallback(() => ActivityService.areThereRecentEventsForPerson(props.student.personId), [props.student.personId]);
    return (_jsx(ActivityFeed, { search: itemSearch, poll: poll, 
        // @ts-expect-error - TS2741 - Property 'opportunity' is missing in type '{ onSearch: Dispatch<SetStateAction<NoteFilters | null | undefined>>; }' but required in type 'Props'.
        filterComponent: _jsx(NoteSearchFilters, { onSearch: setNoteSearch }) }));
};
export default AdvisorStudentsStaffNotesTab;
